function setContentHeight(discount = 174) {
  const headerHeight = document.getElementById('navbarBlur').offsetHeight;
  const windowHeight = window.innerHeight;
  const contentHeight = (windowHeight - headerHeight) - discount;

  document.getElementById('transactionList').style.setProperty('max-height', `${contentHeight}px`);

}

function startResize(discount){

    // Set initial height
    setContentHeight(discount);

    // Update height on window resize
    window.addEventListener('resize', setContentHeight(discount));

}

export default startResize;